import styled from 'styled-components';
import TickImg from '../../assets/onboarding/tick-white.svg';

const TickmarkIcon = styled(TickImg as React.SFC<React.SVGProps<SVGSVGElement>>)`

width: ${props => props.width || '.72rem'};
height: ${props => props.height || '.55rem'};
display: flex;
`;

export default TickmarkIcon;
